import { useState } from 'react';
import { useTranslation } from '../../i18n/hooks/useTranslation';
import {
  IconKeyboard, IconSearch, IconArrowRight, IconArrowLeft,
  IconPin, IconArrowGuide, IconPlus, IconPencil,
} from '@tabler/icons-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { ScrollArea } from '../ui/scroll-area';

export default function AdminShortcutHelpModal({ open, onOpenChange, showTrigger = true }) {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = open !== undefined;
  const opened = isControlled ? open : internalOpen;
  const setOpened = isControlled ? onOpenChange : setInternalOpen;
  const { t } = useTranslation();

  const rows = [
    { shortcut: 'Ctrl + K',           action: t('shortcuts.admin.focusSearch'),                Icon: IconSearch },
    { shortcut: 'Ctrl + Shift + →',   action: t('shortcuts.admin.next'),                       Icon: IconArrowRight },
    { shortcut: 'Ctrl + Shift + ←',   action: t('shortcuts.admin.previous'),                   Icon: IconArrowLeft },
    { shortcut: 'Ctrl + Shift + K',   action: t('shortcuts.admin.openNewTemplateDrawer'),       Icon: IconPlus },
    { shortcut: 'Ctrl + Enter',        action: t('shortcuts.admin.nextSubmitFinish'),            Icon: IconArrowGuide },
    { shortcut: 'Win/Cmd + Shift + N', action: t('shortcuts.admin.addPlaceholderOrDocument'),   Icon: IconPlus },
    { shortcut: 'Ctrl + O',            action: t('shortcuts.admin.openDocumentInEditor'),        Icon: IconPencil },
    { shortcut: 'index + G',           action: t('shortcuts.admin.openGenerateDrawer'),          Icon: IconArrowGuide },
    { shortcut: 'index + P',           action: t('shortcuts.admin.pinUnpin'),                    Icon: IconPin },
  ];

  return (
    <>
      <Dialog open={opened} onOpenChange={setOpened}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>{t('shortcuts.admin.title')}</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-zinc-500 dark:text-zinc-400 -mt-2">{t('shortcuts.admin.tip')}</p>
          <hr className="border-zinc-200 dark:border-zinc-700" />
          <ScrollArea className="h-[400px]">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-zinc-200 dark:border-zinc-700">
                  <th className="text-left py-2 pr-4 w-[35%] font-medium text-zinc-700 dark:text-zinc-300">{t('shortcuts.shortcut')}</th>
                  <th className="text-left py-2 font-medium text-zinc-700 dark:text-zinc-300">{t('shortcuts.action')}</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr key={i} className={i % 2 === 0 ? 'bg-zinc-50 dark:bg-zinc-800/50' : ''}>
                    <td className="py-2 pr-4">
                      <code className="font-mono text-sm text-zinc-700 dark:text-zinc-300">{row.shortcut}</code>
                    </td>
                    <td className="py-2">
                      <span className="inline-flex items-center gap-1.5 text-zinc-700 dark:text-zinc-300">
                        {row.Icon && <row.Icon size={14} className="shrink-0" />}
                        {row.action}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </ScrollArea>
        </DialogContent>
      </Dialog>

      {showTrigger && (
        <button
          onClick={() => setOpened(true)}
          title={t('shortcuts.admin.keyboardShortcuts')}
          aria-label={t('shortcuts.admin.keyboardShortcuts')}
          className="inline-flex items-center justify-center w-8 h-8 rounded-md text-zinc-500 dark:text-zinc-400
            hover:bg-zinc-100 dark:hover:bg-zinc-700 transition-colors"
        >
          <IconKeyboard size={16} />
        </button>
      )}
    </>
  );
}
